import { CSSProperties, ReactNode } from 'react';
import { useReduxState } from 'hooks';
import { Icon } from 'components/common/icons';
import type { IconProp } from 'components/common/icons/Icon';

export interface AvatarProps {
  backgroundColor?: string;
  children?: ReactNode;
  color?: string;
  fontSize?: string;
  icon?: IconProp;
  padding?: string | number;
  size?: string;
  style?: CSSProperties;
}

const Avatar = ({
  backgroundColor,
  children,
  color,
  fontSize = '1.2rem',
  icon,
  padding = '5px 0',
  size = '28px',
  style = {}
}: AvatarProps) => {
  const { theme } = useReduxState();

  return (
    <div
      className="avatar"
      style={{
        backgroundColor: backgroundColor || theme.lightGrey,
        color: color || theme.textColorLight,
        fontSize,
        padding,
        height: size,
        width: size,
        ...style
      }}
    >
      {icon ? (
        <div className="icon">
          <Icon icon={icon} />
        </div>
      ) : children ? (
        children
      ) : null}

      <style jsx>{`
        .avatar {
          border-radius: 50%;
          display: inline-block;
          flex-shrink: 0;
          font-weight: 700;
          text-align: center;
          vertical-align: middle;
        }
      `}</style>
    </div>
  );
};

export default Avatar;
